import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { vanessaMom } from "../characters/VanessaMom";
import { doTransition, doWaitImageByTime, isAnnHate, isFollowingVanessaLead, isJoeEnemy } from "../helpers/helpers";
import { images } from "./images";
import { V8VanessaMCConvAfter } from "./V8";
import { ann } from "../characters/Ann";

export const V8VanessaMCConv = async (): Promise<any> => {
    doTransition(images.v8.V8MorningVanessaConv_0);
    if (isAnnHate()) {
        mc.think(`There she is. Why is she outside her house?`);

    } else {
        if (Question.globalAnswers.v3KeepAnsweringChris) {

            mc.think(`There she is... Time to see what she wanted to talk about.`);
        } else {
            mc.think(`Vanessa? What is she doing outside her house?`);

        }

    }
    ImageClass.setImage(images.v8.V8MorningVanessaConv_1);
    vanessa.talk(`This fucking level!`, { method: "Mumbling" });
    mc.talk(`Hey Vanessa!`, { method: "Shouting" });
    ImageClass.setImage(images.v8.V8MorningVanessaConv_2);
    if (Question.globalAnswers.v3KeepAnsweringChris) {

        vanessa.talk(`Finally!`);
    } else {
        vanessa.talk(`${mc.name}?`);

    }
    ImageClass.setImage(images.v8.V8MorningVanessaConv_3);
    mc.think(`What happened to her clothes...?`);
    if (isAnnHate()) {

    } else {
        if (Question.globalAnswers.v3KeepAnsweringChris) {

        } else {
            ImageClass.setImage(images.v8.V8MorningVanessaConv_4);
            vanessa.talk(`What are you doing here?`);
            mc.talk(`I'm on my way to Ann's house...`);

        }
    }
    if (isFollowingVanessaLead()) {
        ImageClass.setImage(images.v8.V8MorningVanessaConv_4);
        if (Question.globalAnswers.v3KeepAnsweringChris) {
            mc.talk(`I think you got it all wrong.`);

        } else {
            mc.talk(`By the way, I think you got it all wrong.`);
        }
        mc.talk(`I agreed to follow your lead, not the other way around...`);

    } else if (isFollowingVanessaLead() === false) {

        ImageClass.setImage(images.v8.V8MorningVanessaConv_4);
        mc.talk(`Wow, I see you are taking our bet really seriously.`);


    } else {
        ImageClass.setImage(images.v8.V8MorningVanessaConv_4);
        mc.talk(`Is there something wrong?`);
    }
    ImageClass.setImage(images.v8.V8MorningVanessaConv_7);
    vanessa.talk(`What are you talking about?`);

    mc.talk(`I'm talking about your outfit...`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_5);
    mc.talk(`It's just...`);
    mc.talk(`What the fuck happened?`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_6);
    mc.talk(`I hope your grandmother isn't mad for stealing her clothes.`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_6.partials.V8MorningVanessaConv_6_2);
    vanessa.talk(`Say another word and I'll rip off your balls!`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_6);
    mc.talk(`Woah there, relax!`);
    if (Question.globalAnswers.v3KeepAnsweringChris) {

        mc.talk(`Alright, so let's talk about the reason I'm here.`);
        mc.talk(`What was so important you couldn't say it over the phone?`);

        if (Question.globalAnswers.v3KeepAnsweringChris) {
            ImageClass.setImage(images.v8.V8MorningVanessaConv_7);
            vanessa.talk(`So let me start with a very simple question...`);
            ImageClass.setImage(images.v8.V8MorningVanessaConv_8);
            mc.talk(`Ok...`);
            if (mc.properties.annStatus === "gf") {
                vanessa.talk(`What is Ann to you?`);
                ImageClass.setImage(images.v8.V8MorningVanessaConv_4);
                mc.talk(`Isn't it obvious...? She is my girlfriend.`);
                ImageClass.setImage(images.v8.V8MorningVanessaConv_7);
                vanessa.talk(`Exactly.`);
                ImageClass.setImage(images.v8.V8MorningVanessaConv_8);
                vanessa.talk(`So funny thing!`);
                vanessa.talk(`Yesterday I had a chat with Ann... You know, girl talk.`);

                vanessa.talk(`And she thinks the same!`);
                ImageClass.setImage(images.v8.V8MorningVanessaConv_4);
                mc.talk(`Okay... And you brought me over here just to say this?`);
                ImageClass.setImage(images.v8.V8MorningVanessaConv_8);
                ImageClass.setImage({ ...images.v8.V8MorningVanessaConv_6, partialsToDisplay: [images.v8.V8MorningVanessaConv_6.partials.V8MorningVanessaConv_6_2] });
                vanessa.talk(`Of course not!`);
                ImageClass.setImage(images.v8.V8MorningVanessaConv_8);
                vanessa.talk(`Anyway!`);
                vanessa.talk(`We kept talking and she mentioned Chris.`);
                vanessa.talk(`You know Chris, right?`);
                ImageClass.setImage(images.v8.V8MorningVanessaConv_4);
                mc.talk(`I do.`);
                ImageClass.setImage(images.v8.V8MorningVanessaConv_8);
                vanessa.talk(`Of course you do! You allowed them to continue talking and seeing each other.`);
                vanessa.talk(`And that brings me to my next question.`);

            } else {

            }

        } else {

        }
    } else {

    }
    // TODO: door open sounds
    if (Question.globalAnswers.v3KeepAnsweringChris) {
        ImageClass.setImage(images.v8.V8MorningVanessaConv_10);

    } else {
        ImageClass.setImage({ ...images.v8.V8MorningVanessaConv_10, partialsToDisplay: [images.v8.V8MorningVanessaConv_10.partials.V8MorningVanessaConv_10_p] });

    }
    empty.think(`*Door sounds*`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_11);
    mc.think(`Vanessa's mom!`);
    mc.think(`Wow, she looks great... I wonder why she is dressed so fancy at this time of the day.`);
    doWaitImageByTime(images.v8.V8MorningVanessaConv_12);
    vanessaMom.talk(`Hey Sweetheart!`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_13);
    vanessa.talk(`Good afternoon Mother!`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_12);
    vanessaMom.talk(`You're not getting into trouble, right?`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_13);
    vanessa.talk(`Of course not! Me and... Ahem... Joe! Are just talking.`);
    mc.think(`Oh, shit, her mom still thinks I'm Joey. I almost forgot.`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_14);
    vanessaMom.talk(`Good girl.`);
    vanessa.talk(`Hehe.`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_15);
    vanessaMom.talk(`Joe, you are looking handsome as ever.`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_16);
    mc.talk(`Thank you Mrs...`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_16.partials.V8MorningVanessaConv_16_2);
    vanessaMom.talk(`Hart.`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_16);
    mc.talk(`Thank you Mrs. Hart.`);
    await vanessaMom.setQuestion(new Question({ text: `What a polite boy!`, options: { think: false }, key: `v8VanessaConvCheckedVanessaMomCleavage` })
        .option({ title: `Check her cleavage`, key: true })
        .option({ title: `Don't check`, key: false }));


    if (Question.globalAnswers.v8VanessaConvCheckedVanessaMomCleavage) {
        doWaitImageByTime(images.v8.V8MorningVanessaConv_17);
        mc.think(`Nice!`);
        mc.think(`Now I can see where Vanessa got her genes from.`);
        doWaitImageByTime(images.v8.V8MorningVanessaConv_18);

    } else {
        ImageClass.setImage({ ...images.v8.V8MorningVanessaConv_16, partialsToDisplay: [images.v8.V8MorningVanessaConv_16.partials.V8MorningVanessaConv_16_2] });

    }
    vanessaMom.talk(`Ok kids, I'm already late as it is, play nice! Bye!`);
    // 
    if (Question.globalAnswers.v8VanessaConvCheckedVanessaMomCleavage) {
        doWaitImageByTime(images.v8.V8MorningVanessaConv_20);
        vanessa.talk(`Don't tell me you just checked out my mom!`);
        mc.talk(`Haven't you? Her boobs were literally staring at me.`);
        vanessa.talk(`You are shameless, you know that?`);
        mc.talk(`...`);

    } else {
        doWaitImageByTime(images.v8.V8MorningVanessaConv_21);
        mc.talk(`You heard your mom, let's play nice!`);
        vanessa.talk(`Nice try.`);

    }

    if (Question.globalAnswers.v3KeepAnsweringChris) {

        if (mc.properties.annStatus === "gf") {
            mc.talk(`So, what was that about Chris?`);

        }
    }
    if (isAnnHate()) {
        mc.talk(`So? Are you going to tell me the reason I'm here?`);

    } else {
        if (Question.globalAnswers.v3KeepAnsweringChris) {

        } else {
            mc.talk(`Alright... I'll get going now. Ann is waiting.`);
        }

    }
    ImageClass.setImage(images.v8.V8MorningVanessaConv_22);
    vanessa.talk(`Hold on, let me just...`);
    vanessa.talk(`Take this fucking thing off.`);
    doWaitImageByTime(images.v8.V8MorningVanessaConv_23);
    await mc.setQuestion(new Question({ text: `Oh... Now I understand.`, options: { think: false }, key: `V8VanessaConvComplimentedHer` })
        .option({ title: `Compliment her`, key: true })
        .option({ title: `Don't compliment`, key: false }));


    if (Question.globalAnswers.V8VanessaConvComplimentedHer) {
        mc.talk(`Looking great by the way! That outfit is hot!`);
        await mc.set((properties) => {
            properties.vanessaRelationship++;
        });

        ImageClass.setImage(images.v8.V8MorningVanessaConv_24);
    } else {
        mc.talk(`That explains the ugly shirt!`);

    }
    ImageClass.setImage(images.v8.V8MorningVanessaConv_24);
    vanessa.talk(`Like duh!`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_25);
    vanessa.talk(`Did you really think I'd walk around the streets with this hideous shirt?`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_26);
    vanessa.talk(`Fuck that!`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_27);
    mc.talk(`Yeah... I should've have known better.`);
    if (Question.globalAnswers.v3KeepAnsweringChris) {
        return jump(V8VanessaMCConv_AnnSeeingChris, "V8VanessaMCConv_AnnSeeingChris");

    }




    return jump(V8VanessaMCConv_AnnNotSeeingChris, "V8VanessaMCConv_AnnNotSeeingChris");
};

export const V8VanessaMCConv_AnnSeeingChris = async (): Promise<any> => {
    if (mc.properties.annStatus === "gf") {
        ImageClass.setImage({ ...images.v8.V8MorningVanessaConv_28, partialsToDisplay: [images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_1] });
        vanessa.talk(`Enough side-tracking!`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_2);
        vanessa.talk(`So like I said. Ann told me you allowed her to keep talking to Chris.`);
        vanessa.talk(`So I had to ask... What she thinks about him... And she said some really interesting things...`);
        vanessa.talk(`Like, I know she is naive... But I didn't realize how much.`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_28);
        mc.talk(`Can you just say it?`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_2);
        vanessa.talk(`I will, but first... I wanna hear what you think.`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_28);
        await vanessa.setQuestion(new Question({ text: `How do you consider their friendship?`, options: { think: false }, key: `v8VanessaConvHowConsiderAnnChrisFriendship` })
            .option({ title: `Just good friends`, key: `goodFriends` })
            .option({ title: `Lovers`, key: `lovers` })
            .option({ title: `I'm not sure`, key: `dunno` }));


        if (Question.globalAnswers.v8VanessaConvHowConsiderAnnChrisFriendship === "lovers") {
            mc.talk(`Lovers.`);
            ImageClass.setImage(images.v8.V8MorningVanessaConv_29);
            vanessa.talk(`REALLY?!`);
            mc.talk(`He flirted with her since day one...`);
            mc.talk(`It would've been stupid of me to think otherwise.`);


        } else if (Question.globalAnswers.v8VanessaConvHowConsiderAnnChrisFriendship === "goodFriends") {
            mc.talk(`They're just good friends.`);
            ImageClass.setImage(images.v8.V8MorningVanessaConv_29);
            vanessa.talk(`Haha!`);
            mc.talk(`What?`);
        } else {
            mc.talk(`I'm not sure.`);
            vanessa.talk(`I'll help you.`);
        }
        ImageClass.setImage({ ...images.v8.V8MorningVanessaConv_28, partialsToDisplay: [images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_1] });
        vanessa.talk(`So apparently Ann consider him as her... Wait for it...`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_29);
        vanessa.talk(`Boyfriend!`);
        vanessa.talk(`Isn't that crazy?`);
        vanessa.talk(`They grow up so fast!`);
        vanessa.talk(`From having no boyfriends, she now has... Two!`);

        ImageClass.setImage(images.v8.V8MorningVanessaConv_28);
        await vanessa.setQuestion(new Question({ text: `How do you feel about that?`, options: { think: false }, key: `V8VanessaConvOkWithAnnChris` })
            .option({ title: `I'm okay with that`, key: true })
            .option({ title: `I'm not okay with that`, key: false }));


        if (Question.globalAnswers.V8VanessaConvOkWithAnnChris) {
            mc.talk(`I'm okay with that.`);
            ImageClass.setImage(images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_2);
            vanessa.talk(`Really now?`);
            ImageClass.setImage(images.v8.V8MorningVanessaConv_28);
            mc.talk(`Yup.`);
            ImageClass.setImage(images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_2);
            vanessa.talk(`Does she let you be with other girls?`);
            if (Question.globalAnswers.v4SexTapeFuckedVanessa || Question.globalAnswers.v6HadSexVanessaLivingRoom) {
                vanessa.talk(`Not that you need her approval... You had no problem fucking me.`);
            } else {

            }
            ImageClass.setImage(images.v8.V8MorningVanessaConv_28);
            mc.talk(`I never asked.`);
            if (Question.globalAnswers.todWatchedJoeVanessaFucking || Game.seenScenarios.includes(`V7ReturningOutfit_LivingRoomEarlyMarioVanessaFuck`)) {
                ImageClass.setImage(images.v8.V8MorningVanessaConv_29);
                let and = '';
                vanessa.talk(`I should've known you like to watch.`);
                if (Game.seenScenarios.includes(`V7ReturningOutfit_LivingRoomEarlyMarioVanessaFuck`)) {
                    vanessa.talk(`The way you watched me and Mario... You LOVED that!`);
                    and = 'And ';
                }
                if (Question.globalAnswers.todWatchedJoeVanessaFucking) {

                    vanessa.talk(`${and}I still remember how you watched me and Joe fucking in your living room.`);
                    vanessa.talk(`At first I thought you just came to check on the noises...`);
                    vanessa.talk(`I guess I'm also naive! Haha!`);
                }
                ImageClass.setImage({ ...images.v8.V8MorningVanessaConv_28, partialsToDisplay: [images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_2] });
                vanessa.talk(`Anyway! You should ask her. Maybe she'll give you a pass.`);
            } else {
                ImageClass.setImage(images.v8.V8MorningVanessaConv_29);
                vanessa.talk(`You should. Maybe she would give you a pass.`);
            }
            ImageClass.setImage(images.v8.V8MorningVanessaConv_29);
            vanessa.talk(`Like the little arrangement Joe and I have.`);
            mc.talk(`And look how it worked out for you two...`);
            ImageClass.setImage(images.v8.V8MorningVanessaConv_30);
            vanessa.talk(`Yeah...`);


        } else {
            mc.talk(`I'm not okay with that.`);
            ImageClass.setImage({ ...images.v8.V8MorningVanessaConv_28, partialsToDisplay: [images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_1] });
            vanessa.talk(`So you're stupid.`);
            mc.talk(`What the fuck?`);
            ImageClass.setImage(images.v8.V8MorningVanessaConv_30);

            vanessa.talk(`You cooked that meal yourself.`);
            vanessa.talk(`From what she's told me, it was clear he had romantic intentions. Yet you allowed it.`);
            ImageClass.setImage(images.v8.V8MorningVanessaConv_28);
            mc.talk(`...`);
            ImageClass.setImage(images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_2);
            vanessa.talk(`It can be a good thing!`);
            ImageClass.setImage(images.v8.V8MorningVanessaConv_28);
            mc.talk(`How's that?`);
            ImageClass.setImage(images.v8.V8MorningVanessaConv_30);
            vanessa.talk(`Just talk to her and tell her you're gonna do the same. See how she reacts.`);
            vanessa.talk(`Think about that, since she doesn't see a problem meeting you both, she shouldn't get upset when you do it.`);
            mc.talk(`Yeah it makes sense when you put it that way.`);
            if (Question.globalAnswers.v4SexTapeFuckedVanessa || Question.globalAnswers.v6HadSexVanessaLivingRoom) {
                ImageClass.setImage(images.v8.V8MorningVanessaConv_29);

                vanessa.talk(`Or just keep fucking her best friend behind her back.`);
                mc.talk(`I still haven't fucked her best friend.`);
                ImageClass.setImage(images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_1);
                vanessa.talk(`What the fuck?! I was talking about me!`);
                mc.talk(`Oh.`);
            } else {


            }
        }

    }
    return jump(V8VanessaMCConv_END, "V8VanessaMCConv_END");
};
export const V8VanessaMCConv_AnnNotSeeingChris = async (): Promise<any> => {
    if (isAnnHate()) {
        mc.talk(`Well...?`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_2, { putParent: true });
        vanessa.talk(`I wanted to ask you a favor.`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_30);
        mc.talk(`Why couldn't you ask it over the phone?`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_1, { putParent: true });
        vanessa.talk(`Because I didn't want to.`);
        mc.talk(`...`);
        mc.talk(`What's the favor?`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_2);
        vanessa.talk(`Can you just please fuck Ann already?`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_28);
        mc.talk(`Where is that came from?`);
        mc.talk(`And isn't she with Chris?`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_2);
        vanessa.talk(`Fuck him.`);
        if (Question.globalAnswers.v2AgreeToSeeBJPic) {
            mc.talk(`Are we talking about the same guy you gave blowjob to?`);
            ImageClass.setImage(images.v8.V8MorningVanessaConv_30);
            vanessa.talk(`So?`);
            mc.talk(`...`);

        } else {

        }
        mc.talk(`Why do you want me to fuck her?`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_2, { putParent: true });
        vanessa.talk(`Can't you see?`);
        vanessa.talk(`The girl is doing anything in her power to make you jealous and you don't give a fuck.`);
        vanessa.talk(`I can't believe I'm saying this, but she's actually playing Chris to get you.`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_28);
        mc.talk(`Did she tell this to you?`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_2);
        vanessa.talk(`No.`);
        vanessa.talk(`But you need to be blind to see it.`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_28);
        mc.talk(`How is me fucking her going to solve it?`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_2);
        vanessa.talk(`She needs to get it out of her system.`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_28);
        mc.talk(`I'll consider it.`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_2);
        vanessa.talk(`That's all I ask.`);
        if (!isJoeEnemy()) {
            vanessa.talk(`And one last thing...`);
        }

    } else {

    }



    if (isJoeEnemy()) {
        // TODO: Joe rival
    } else {
        ImageClass.setImage({ ...images.v8.V8MorningVanessaConv_28, partialsToDisplay: [images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_2] });
        vanessa.talk(`Have you talked to Joe today?`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_30);
        mc.talk(`No... why?`);
        ImageClass.setImage({ ...images.v8.V8MorningVanessaConv_28, partialsToDisplay: [images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_2] });
        vanessa.talk(`Just curious. Let me know once you do.`);
        ImageClass.setImage(images.v8.V8MorningVanessaConv_30);
        mc.talk(`Ok...`);

    }

    return jump(V8VanessaMCConv_END, "V8VanessaMCConv_END");
};

export const V8VanessaMCConv_END = async (): Promise<any> => {
    ImageClass.setImage(images.v8.V8MorningVanessaConv_30);
    if (Question.globalAnswers.v3KeepAnsweringChris) {

        vanessa.talk(`Alright, I have some things to take care of!`);
    } else {
        vanessa.talk(`Alright, I also have things to take care of!`);

    }
    if (Question.globalAnswers.V8VanessaConvOkWithAnnChris) {
        mc.talk(`Smooth way to ignore this conversation...`);

    }
    if (!isFollowingVanessaLead()) {
        mc.talk(`Don't you go fucking people, or objects, without my approval!`);
        ImageClass.setImage({ ...images.v8.V8MorningVanessaConv_28, partialsToDisplay: [images.v8.V8MorningVanessaConv_28.partials.V8MorningVanessaConv_28_1] });
        vanessa.talk(`Unfortunately... I remember.`);
        vanessa.talk(`Bye!`);

    } else {

    }

    ImageClass.setImage(images.v8.V8MorningVanessaConv_31, { wait: true, hideText: true });
    ImageClass.setImage(images.v8.V8MorningVanessaConv_32);
    vanessa.talk(`Are you still here?`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_33);
    mc.talk(`I'm wondering why you threw your shirt if you knew you were just gonna pick it back up?`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_32);
    vanessa.talk(`For the dramatic effect... Like DUH!`);
    ImageClass.setImage(images.v8.V8MorningVanessaConv_33);
    mc.talk(`Makes sense...`);
    // TODO: make sure you find this package for all routes
    // TODO: SUGGESTION -> DURING THE CONVERSATION WITH THE PCLADY -> (ANN + ALEX) -> HE CAN MENTION HE SAW THE PACKAGE AND PUT IT INSIDE HIS ROOM FOR LATER USE
    // SHE'LL ASK WHY IT'S IMPORTANT, HE'LL SAY -> THAT'S FOR LATER.
    vanessa.talk(`Oh.. And I ordered a package to your address, save it for me.`);
    mc.talk(`Why not to yours?`);
    vanessa.talk(`Should I state the obvious...? Just hold it for me until I pick it up.`);
    vanessa.talk(`Thanks, byeeee!`);

    return jump(V8VanessaMCConvAfter, "V8VanessaMCConvAfter");
};